import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
var LocalStorage = /*#__PURE__*/function () {
  function LocalStorage() {
    _classCallCheck(this, LocalStorage);
    this.data = {};
    this.length = 0;
  }
  _createClass(LocalStorage, [{
    key: "clear",
    value: function clear() {
      this.data = {};
      this.length = 0;
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      var item = this.data[key];
      return item || null;
    }
  }, {
    key: "key",
    value: function key(index) {
      var keys = Object.keys(this.data);
      return keys[index] || null;
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      if (this.data[key]) {
        delete this.data[key];
        this.length--;
      }
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      if (!this.data[key]) {
        this.length++;
      }
      this.data[key] = value;
    }
  }]);
  return LocalStorage;
}();
export { LocalStorage as default };